// MAABAR's three sourcing services — their names (exactly as on the home page
// and in the trader's menus) and their EXISTING routes. One definition, used by
// the header's services menu and the market home's strip. Never "طلب تسعير".
//   الطلب المُدار → the managed wizard (/request)
//   اطلب عرض سعر  → a direct RFQ (/requests?mode=direct)
//   صنّع فكرتك    → the IdeaToProduct tool, opened through the global AIHub the
//                   way the trader bottom nav's "+" opens it
export const SERVICES = [
  { key: 'managed', ar: 'الطلب المُدار', en: 'Managed order', zh: '代管采购', go: (nav) => nav('/request') },
  { key: 'rfq', ar: 'اطلب عرض سعر', en: 'Request a quote', zh: '询价', go: (nav) => nav('/requests?mode=direct') },
  { key: 'idea', ar: 'صنّع فكرتك', en: 'Make your idea', zh: '定制你的创意', go: () => window.dispatchEvent(new CustomEvent('maabar:open-idea')) },
];
export const SERVICE_ROUTES = Object.fromEntries(SERVICES.map((s) => [s.key, s.go]));
